export enum StoreLocatorServiceModeTab {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
}
